import axios from 'axios';
import * as Moment from 'moment-timezone';
import moment from 'moment-timezone';
import queryString from 'query-string';
import {
    FormEvent,
    FunctionComponent,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import BookingAPI, { BookingMenuSelection } from '../../api/booking.api';
import bugsnag from '../../bugsnag';
import Button from '../../components/common/Button';
import Checkbox from '../../components/common/Checkbox';
import CountryCodeSelector, {
    getCodeByCountryRegion,
    getCountryByCode,
} from '../../components/CountryCodeSelector';
import ExpirationTimer from '../../components/ExpirationTimer';
import Footer from '../../components/Footer';
import HeaderOLD from '../../components/OLD_Header';
import LoadingPage from '../../components/LoadingPage';
import { BookingProcessStoreContext } from '../../stores/BookingProcessStore';
import { validateEmail } from '../../utils/Email';
import { PaymentRedirectListener } from '../../components/PaymentRedirect';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import theme from '../../styles/theme';
import { Controller, useForm } from 'react-hook-form';
import { matchCodeToPhone } from '../../utils/Phone';
import InputMask from 'react-input-mask';
import Payment from 'payment';
import { CreditCardContainer } from '../../styles/CreditCardInput.styled';
import { getCardType as getCardIcon } from '../../utils/CardUtils';
import CardType from '../../enums/CardType';
import { useCookieValue } from '../../hooks/useCookieValue';
import { CompleteBookingResponseModel } from '../../payments/BaseCompleteResponseModel';
import { currencies, currencyFormat } from '../../utils/currencyUtils';
import { CurrencyISO4217 } from '../../types/CurrencyISO4217';
import {
    getGoogleReserveCookie,
    trackGoogleReserveConversion,
} from '../../utils/GoogleReserveUtils.ts';
import { trackDineout, trackDineoutDiscovery } from '@dineouticeland/do-tracking';
import { useCompanyIdentifier } from '../../contexts/TrackingContext.tsx';
import { normaliseHTMl } from '../TA/utils/itemUtils.ts';

const NoShowTextWrapper = styled.div`
    font-size: 14px;
    line-height: 1.43;
    color: #1c1c1c;

    p {
        font-size: 12px !important;
        line-height: 1.66;
        margin: 0;
    }
`;

const Style = styled.div`
    background-color: #f7f8fa;

    .h-header {
        padding: 16px;
        background-color: rgba(247, 248, 250, 0.72);
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        border-bottom: 1px solid rgba(28, 28, 28, 0.05);
    }

    .rest-text {
        > p {
            margin: 0px;
            white-space: pre-wrap;
        }
    }

    > div:first-child {
        background-color: #fff;
    }

    .compl-header-info.container {
        padding-top: 8px;
        padding-bottom: 4px;
        color: #9b9b9b;
        font-weight: 200;

        @media screen and (min-width: 768px) {
            padding-top: 16px;
            padding-bottom: 4px;
        }
    }

    .compl-booking-details {
        border-top: 1px solid #f7f7f7;
        border-bottom: 1px solid #f7f7f7;

        > .container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 0px;
            padding-bottom: 0px;

            .compl-booking-details-item {
                flex-basis: 33.333%;
                padding-top: 24px;
                padding-bottom: 16px;

                &:nth-child(1),
                &:nth-child(2) {
                    /* Right border for first two items in mobile */
                    border-right: 1px solid #f7f7f7;
                }

                &:nth-child(2),
                &:nth-child(3) {
                    /* Spacing for last two items in first row mobile */
                    padding-left: 16px;
                }

                &:last-child {
                    /* Reservation time 100% width in mobile */
                    flex-basis: 100%;
                }

                @media screen and (min-width: 960px) {
                    &:nth-child(-n + 3) {
                        /* Day, time, guests widths */
                        flex-basis: 20%;
                    }

                    &:last-child {
                        /* Reservation time width */
                        flex-basis: 40%;
                    }

                    &:not(:first-child) {
                        /* Give padding to time, guests and reservation time */
                        padding-left: 16px;
                    }

                    &:nth-child(1),
                    &:nth-child(2),
                    &:nth-child(3) {
                        /* Right border first three items */
                        border-right: 1px solid #f7f7f7;
                    }
                }

                > div:first-child {
                    display: block;
                    margin-bottom: 8px;
                    font-size: 12px;
                    font-weight: 200;
                    text-transform: uppercase;
                    color: #9b9b9b;
                    letter-spacing: 0.333px;
                }

                > div:last-child {
                    display: flex;
                    height: 48px;
                    align-items: center;
                    font-weight: 300;
                    font-size: 20px;
                }
            }
        }
    }

    .compl-terms-checkbox {
        margin-bottom: 24px;
    }

    .compl-terms-error {
        color: ${theme.palette.error.main};
    }

    .compl-forms-container {
        padding-bottom: 24px;
        background-color: #f7f8fa;

        .compl-forms-row {
            display: flex;
            flex-wrap: wrap;

            > * {
                min-height: 64px;
                margin-bottom: 16px;
            }

            &:first-child {
                > div {
                    &:first-child {
                        margin-right: 16px;
                    }

                    &:first-child,
                    &:nth-child(2) {
                        /* First and last name inline */
                        flex-basis: calc(50% - 8px);
                    }
                }
            }

            &:nth-child(2) {
                > *:first-child {
                    flex-basis: calc(((100% - 16px) / 3) * 1);
                    margin-right: 16px;
                }

                > div.c-phone {
                    flex-basis: calc(((100% - 16px) / 3) * 2);
                }
            }

            @media screen and (min-width: 768px) {
                &:first-child {
                    /* First input row */
                    flex-wrap: nowrap;

                    > input {
                        flex-basis: 100%;

                        &:not(:last-child) {
                            margin-right: 16px;
                        }
                    }

                    > div {
                        flex-basis: 100%;

                        &:not(:last-child) {
                            margin-right: 16px;
                        }
                    }
                }

                &:nth-child(2) {
                    flex-wrap: nowrap;

                    > *:first-child {
                        flex-basis: calc(((100% - 16px) / 3) * 1);
                        margin-right: 16px;
                    }

                    > div.c-phone {
                        flex-basis: calc(((100% - 16px) / 3) * 2);
                        margin-right: 16px;
                    }
                }
            }
        }
    }

    .compl-newsletter-checkboxes {
        display: flex;
        flex-direction: row;
        padding: 8px 0px 32px 0px;

        @media screen and (min-width: 768px) {
            flex-direction: row;
        }

        button:first-child {
            margin-right: 16px;
            margin-bottom: 16px;

            @media screen and (min-width: 768px) {
                margin-bottom: 0px;
            }
        }
    }

    .btn {
        height: 64px;
        max-width: 408px;
    }
`;

const ResendCodeButton = styled.button`
    background: transparent;
    border: 0;
    padding: 0;
    margin-left: 4px;
    color: ${theme.palette.primary.main};
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const DietarySection = styled.div`
    padding: 8px 0px 8px 0px;

    > h3 {
        margin: 0px 0px 8px 0px;
        font-size: 20px;
        font-weight: 300;
    }

    > p {
        margin: 0px 0px 24px 0px;
        font-size: 14px;
        line-height: 1.5;
        color: #9b9b9b;
        white-space: pre-wrap;
    }
`;

const DietaryOptions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;

    @media screen and (min-width: 768px) {
        flex-direction: row;
    }
`;

const DietaryOption = styled.button<{ selected: boolean }>`
    display: flex;
    align-items: center;
    flex: 1;
    min-height: 64px;
    padding: 0px 24px;
    background-color: ${(props) =>
        props.selected ? 'rgba(255, 110, 61, 0.08)' : '#fff'};
    border: 1px solid
        ${(props) => (props.selected ? theme.palette.primary.main : '#e9eef3')};
    border-radius: 8px;
    font-size: 16px;
    font-weight: 300;
    color: #1c1c1c;
    cursor: pointer;
    text-align: left;

    .c-radio {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 12px;
        border-radius: 50%;
        border: 1px solid
            ${(props) =>
                props.selected ? theme.palette.primary.main : '#c4c4c4'};
        flex-shrink: 0;

        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: ${theme.palette.primary.main};
            display: ${(props) => (props.selected ? 'block' : 'none')};
        }
    }
`;

const DietaryTextArea = styled.textarea`
    width: 100%;
    min-height: 96px;
    padding: 16px;
    box-sizing: border-box;
    resize: vertical;
    font-family: inherit;
    font-size: 16px;
    font-weight: 300;
    background-color: #fff;
    border: 1px solid #e9eef3;
    border-radius: 3px;

    ::placeholder {
        opacity: 0.7;
    }
`;

const SectionEyebrow = styled.div`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: ${theme.palette.primary.main};
    margin-bottom: 6px;
`;

const SectionHeading = styled.div`
    font-size: 24px;
    font-weight: 300;
    line-height: 1.2;
    color: #1c1c1c;
    margin-bottom: 8px;

    @media screen and (min-width: 768px) {
        font-size: 28px;
    }
`;

const SectionSubtitle = styled.p`
    font-size: 14px !important;
    line-height: 1.5 !important;
    color: #9b9b9b;
    margin: 0 0 24px 0 !important;
`;

const FormSection = styled.section`
    margin-bottom: 4px;
`;


const BookingSummaryCard = styled.div`
    background: #fff;
    border: 1px solid #e9eef3;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    padding: 4px 24px;
    margin-bottom: 16px;

    .bs-item {
        flex-basis: 33.333%;
        padding: 16px 0px;

        &:last-child {
            flex-basis: 100%;
            border-top: 1px solid #f0f0f0;
        }

        @media screen and (min-width: 768px) {
            &:nth-child(-n + 3) {
                flex-basis: 20%;
            }

            &:last-child {
                flex-basis: 40%;
                border-top: none;
            }

            &:not(:first-child) {
                border-left: 1px solid #f0f0f0;
                padding-left: 24px;
            }
        }

        .bs-label {
            margin-bottom: 8px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            color: #9b9b9b;
        }

        .bs-value {
            display: flex;
            align-items: center;
            min-height: 32px;
            font-size: 20px;
            font-weight: 300;
            color: #1c1c1c;
        }
    }
`;

const PolicyCard = styled.div`
    background: #fff;
    border: 1px solid #e9eef3;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    padding: 20px;
    margin-bottom: 28px;

    @media screen and (min-width: 768px) {
        flex-direction: row;
    }

    .pc-side {
        flex-shrink: 0;
        margin-bottom: 16px;

        @media screen and (min-width: 768px) {
            flex-basis: 220px;
            margin-bottom: 0px;
            padding-right: 24px;
        }
    }

    .pc-title {
        font-size: 18px;
        font-weight: 400;
        color: #1c1c1c;
    }

    .pc-text {
        flex: 1;
        font-size: 14px;
        line-height: 1.6;
        color: #4a4a4a;

        @media screen and (min-width: 768px) {
            border-left: 1px solid #f0f0f0;
            padding-left: 24px;
        }

        p {
            margin: 0px;
            font-size: 14px;
            line-height: 1.6;
            white-space: pre-wrap;
        }
    }
`;

const ChargesCard = styled.div`
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
    padding: 16px 20px;
    background: #fff6f2;
    border: 1px solid #ffd6c4;
    border-radius: 10px;

    .charges-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        font-size: 15px;
        font-weight: 500;
        color: #1c1c1c;

        i {
            font-size: 18px;
            color: ${theme.palette.primary.main};
        }
    }

    ul {
        margin: 0px;
        padding-left: 20px;
    }

    li {
        font-size: 14px;
        line-height: 1.5;
    }
`;

const bookingApi = new BookingAPI();

type BookingInfoType = {
    start: Moment.Moment;
    guests: number;
    restaurantId: number;
    restaurantName: string;
    paymentRequirements: { totalNoShow: number; totalPrepaid: number };
    menus: BookingMenuSelection[];
    paymentRequired: boolean;
    gaTrackingId: string | null;
    fbPixelId: string | null;
    requirePolicyAccept: boolean;
    requireEmailMarketingConfirmation: boolean;
    requireAllergenInfo: boolean;
    policyText: string | null;
    noShowText: string | null;
    isExternalPaymentForm: boolean;
    currency: CurrencyISO4217;
    locale: string;
} | null;

type BookingFormType = {
    firstName: string;
    lastName: string;
    phone: string;
    emailAddress: string;
    specialRequest: string;
    cardNumber: string;
    cardExpiry: string;
    cardCvc: string;
    allowSMSMarketing: boolean;
    allowRestaurantEmails: boolean;
    hasAllergies: boolean;
    bookingDietaryRestrictions: string;
    isWaitingListOnly: boolean;
    countryCode: number | null;
    expired: boolean;
};

type CompleteBookingRequestPayload = {
    bookingName: string;
    bookingPhone: string;
    phoneNumberRegion: string | null;
    bookingEmail: string;
    bookingSpecialRequest: string;
    cardNumber: string;
    cardExpiryMonth: string;
    cardExpiryYear: string;
    cardCvc: number | null;
    allowDineoutEmails: boolean;
    allowRestaurantEmails: boolean;
    referrerCode: string | null;
    isWaitingList: boolean;
    bookingDietaryRestrictions: string;
    hasAllergies: boolean;
};

type IProps = RouteComponentProps<any>;

const Complete: FunctionComponent<IProps> = () => {
    const { t, i18n } = useTranslation();

    const {
        guid,
        isWaitingList,
        isWaitingListWhenFullyBooked,
        expires: expiresStr,
    }: {
        guid: string;
        isWaitingList: string;
        isWaitingListWhenFullyBooked: string;
        expires: string;
    } = queryString.parse(window.location.search) as {
        guid: string;
        isWaitingList: string;
        isWaitingListWhenFullyBooked: string;
        expires: string;
    };

    const { restaurantId } = queryString.parse(window.location.search);

    // Set company identifier for restaurant-level tracking (cleared on unmount).
    useCompanyIdentifier(restaurantId as string);

    useEffect(() => {
        trackDineoutDiscovery('Reservation Step Viewed', { step: 'checkout' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [bookingInfo, setBookingInfo] = useState<BookingInfoType>(null);
    const BookingProcessStore = useContext(BookingProcessStoreContext);

    const waitingListOnly = Boolean(
        isWaitingList && isWaitingList.toLowerCase() === 'true',
    );
    const waitingListWhenFullyBooked = Boolean(
        isWaitingListWhenFullyBooked &&
            isWaitingListWhenFullyBooked.toLowerCase() === 'true',
    );
    const isWaitingListBooking = waitingListOnly || waitingListWhenFullyBooked;
    const expires = moment(parseInt(expiresStr, 10));

    const [response, setResponse] =
        useState<CompleteBookingResponseModel | null>(null);
    const [lastSubmittedPayload, setLastSubmittedPayload] =
        useState<CompleteBookingRequestPayload | null>(null);
    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [isSubmittingCode, setIsSubmittingCode] = useState(false);
    const [isResendingCode, setIsResendingCode] = useState(false);
    const [verificationMessage, setVerificationMessage] = useState<
        string | null
    >(null);
    const [verificationMessageTone, setVerificationMessageTone] = useState<
        'info' | 'error'
    >('info');

    let referrerCode = useCookieValue<string | null>('do_referrer', null);
    if (
        referrerCode === null &&
        !!getGoogleReserveCookie(bookingInfo?.restaurantId)
    ) {
        referrerCode = 'GOGL_RESRV';
    }

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();

        bookingApi
            .getBookingInfoForComplete(guid, isWaitingListBooking, cancelToken)
            .then((res) => {
                //say what kind of form it is
                trackDineout('Reservation Checkout Loaded', {
                    restaurant_id: res.data.restaurantId.toString(),
                    dateTime: res.data.start,
                    guests: res.data.guests,
                    lng: i18n.language,
                });

                const paymentRequired =
                    res.data.paymentRequirements.totalNoShow > 0 ||
                    res.data.paymentRequirements.totalPrepaid > 0;
                if (paymentRequired) {
                    trackDineout('Payment Required Shown', {
                        required: true,
                        amount: res.data.paymentRequirements.totalPrepaid,
                        reason:
                            res.data.paymentRequirements.totalPrepaid > 0
                                ? 'prepaid'
                                : 'noshow',
                    });
                }
                setBookingInfo({
                    ...res.data,
                    start: moment(res.data.start, moment.defaultFormatUtc),
                    paymentRequired: paymentRequired,
                });

                // TODO: fix this hack. NB shouldn't be the country for Norway but should be NO.
                // NB is the language, NO is the country!
                const countryCode =
                    getCodeByCountryRegion(
                        res.data.restaurantCountry === 'nb'
                            ? 'no'
                            : res.data.restaurantCountry,
                    ) || 354;
                // setCountryCode(countryCode);
                reset({ ...getValues(), countryCode: countryCode });
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    bugsnag.notify(e);
                    throw new Error(
                        'Error fetching booking info for complete.',
                    );
                }
            });

        return () => cancelToken.cancel('Complete cancel token cancelled.');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    const {
        control,
        formState: { errors },
        handleSubmit,
        getValues,
        setValue,
        reset,
        watch,
    } = useForm<BookingFormType>({
        defaultValues: {
            firstName: '',
            lastName: '',
            phone: '',
            emailAddress: '',
            specialRequest: '',
            cardNumber: '',
            cardExpiry: '',
            cardCvc: '',
            allowSMSMarketing: false,
            allowRestaurantEmails: false,
            hasAllergies: false,
            bookingDietaryRestrictions: '',
            isWaitingListOnly: false,
            countryCode: 354,
            expired: false,
        },

        mode: 'onBlur',
    });

    const watchPhone = watch('phone');
    const isExpired: boolean = watch('expired');

    const creditCardIcon = (cardNumber: string, isCardNumberValid: boolean) => {
        const cardType = Payment.fns.cardType(cardNumber);
        if (cardType === 'visa') {
            return getCardIcon(CardType.Visa);
        } else if (cardType === 'mastercard') {
            return getCardIcon(CardType.MasterCard);
        } else if (isCardNumberValid) {
            return '💳';
        }
    };
    const [isLoading, setIsLoading] = useState(false);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptTermsError, setAcceptTermsError] = useState<
        string | undefined
    >();

    const onCompleteSuccess = () => {
        setResponse(null);
        trackGoogleReserveConversion(bookingInfo?.restaurantId);
        trackDineout('Reservation Completed', {
            restaurant_id: bookingInfo?.restaurantId?.toString() ?? '',
            reservation_id: guid,
            payment_required: !!bookingInfo?.paymentRequired,
        });

        BookingProcessStore.nextStep();
    };

    const onCompleteError = () => {
        setIsLoading(false);
        setResponse(null);
        alert(t('pages.complete.couldNotFinishBooking'));
    };

    const sendCompleteRequest = (
        payload: CompleteBookingRequestPayload,
        options?: {
            verificationCode?: string | null;
            onBeforeRequest?: () => void;
            onFinally?: () => void;
        },
    ) => {
        const cancelToken = axios.CancelToken.source();

        options?.onBeforeRequest?.();

        bookingApi
            .complete(
                guid,
                payload.bookingName,
                payload.bookingPhone,
                payload.phoneNumberRegion,
                payload.bookingEmail,
                payload.bookingSpecialRequest,
                payload.cardNumber,
                payload.cardExpiryMonth,
                payload.cardExpiryYear,
                payload.cardCvc,
                payload.allowDineoutEmails,
                payload.allowRestaurantEmails,
                payload.referrerCode,
                payload.isWaitingList,
                payload.bookingDietaryRestrictions,
                payload.hasAllergies,
                cancelToken,
                options?.verificationCode ?? null,
            )
            .then((res) => {
                const mdl = new CompleteBookingResponseModel(res.data);
                setResponse(mdl);

                if (mdl.isSuccess()) {

                    setIsVerificationModalOpen(false);
                    setVerificationCode('');
                    setVerificationMessage(null);
                    setVerificationMessageTone('info');
                    onCompleteSuccess();
                } else if (mdl.isVerificationRequired()) {
                    trackDineout('Reservation Verification Needed', {
                        reservation_id: guid,
                        verification_type: 'email',
                    });
                    setIsVerificationModalOpen(true);
                    if (!options?.verificationCode) {
                        setVerificationCode('');
                    }
                    setVerificationMessage(mdl.message ?? null);
                    setVerificationMessageTone(
                        options?.verificationCode ? 'error' : 'info',
                    );
                } else if(mdl.isPaymentRedirect()){
                    trackDineout('Reservation Payment Redirect', {
                        provider: mdl.paymentProviderType?.toString(),
                        redirect_type: '3ds',
                    });
                } else if (mdl.isError() || !mdl.isPaymentRedirect()) {
                    trackDineout('Reservation Failed', {
                        reservation_id: guid,
                        type: 'semi_unknown',
                        reason: 'provider_error',
                    });
                    setIsVerificationModalOpen(false);
                    setVerificationMessage(null);
                    onCompleteError();
                }
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    bugsnag.notify(e);
                    trackDineout('Reservation Failed', {
                        reservation_id: guid,
                        type: 'unknown',
                        reason: 'unknown',
                    });
                    throw new Error(t('pages.complete.errorCompletingBooking'));
                }
            })
            .finally(() => {
                options?.onFinally?.();
            });
    };

    const completeBooking = (values: BookingFormType) => {

        trackDineout('Customer Details Submitted', {
            has_email: true,
            has_phone: true,
            has_special_request: false,
        });
        if (!acceptTerms) {
            setIsLoading(false);
            setAcceptTermsError(t('pages.complete.acceptTermsError'));
            return;
        }

        if (bookingInfo) {
            setAcceptTermsError(undefined);
            const bookingName = (
                values.firstName +
                ' ' +
                values.lastName
            ).trim();
            const phoneNumber = '+' + values.countryCode + values.phone;

            const country = values.countryCode
                ? getCountryByCode(values.countryCode, values.phone)
                : null;
            const countryCodeRegion = country ? country.region : null;
            const [rawExpiryMonth, rawExpiryYear] =
                values.cardExpiry.split('/');
            const cardExpiryMonth = rawExpiryMonth ? rawExpiryMonth.trim() : '';
            const cardExpiryYear = rawExpiryYear ? rawExpiryYear.trim() : '';

            const payload: CompleteBookingRequestPayload = {
                bookingName,
                bookingPhone: phoneNumber,
                phoneNumberRegion: countryCodeRegion,
                bookingEmail: values.emailAddress,
                bookingSpecialRequest: values.specialRequest,
                cardNumber: values.cardNumber,
                cardExpiryMonth,
                cardExpiryYear,
                cardCvc: values.cardCvc ? parseInt(values.cardCvc, 10) : null,
                allowDineoutEmails: values.allowSMSMarketing,
                allowRestaurantEmails: values.allowRestaurantEmails,
                referrerCode,
                isWaitingList: isWaitingListBooking,
                bookingDietaryRestrictions: values.hasAllergies
                    ? values.bookingDietaryRestrictions
                    : '',
                hasAllergies: values.hasAllergies,
            };

            setLastSubmittedPayload(payload);

            sendCompleteRequest(payload, {
                onBeforeRequest: () => setIsLoading(true),
                onFinally: () => setIsLoading(false),
            });
        }
    };

    const handleVerificationSubmit = (event?: FormEvent<HTMLFormElement>) => {
        event?.preventDefault();

        if (!lastSubmittedPayload) {
            return;
        }

        const trimmedCode = verificationCode.trim();

        if (!trimmedCode) {
            setVerificationMessageTone('error');
            setVerificationMessage(
                t('pages.complete.emailVerification.codeRequired'),
            );
            return;
        }

        setVerificationMessage(null);
        setVerificationMessageTone('info');
        trackDineout('Customer Details Submitted', {
            has_email: true,
            has_phone: true,
            has_special_request: true,
        });
        sendCompleteRequest(lastSubmittedPayload, {
            verificationCode: trimmedCode,
            onBeforeRequest: () => setIsSubmittingCode(true),
            onFinally: () => setIsSubmittingCode(false),
        });
    };

    const handleResendVerificationCode = async () => {
        if (!lastSubmittedPayload) {
            return;
        }

        setVerificationMessage(null);
        setVerificationMessageTone('info');

        const cancelToken = axios.CancelToken.source();
        setIsResendingCode(true);

        // Not working need to check why the backend isnt accepting the bearer token to be able to rate limit this endpoint
        /*let user = auth.currentUser;

        if (!user) {
            user = (await signInAnonymously(auth)).user;
        }

        const token = await user!.getIdToken(true);*/

        try {
            const res = await bookingApi.resendVerification(guid, cancelToken);

            // Handle new endpoint behaviours
            // 200 OK => response body is a string prompt
            if (res.status === 200) {
                const prompt =
                    typeof res.data === 'string' && res.data
                        ? res.data
                        : `We've sent a new verification code. Please enter it to confirm your booking.`;
                setVerificationMessage(prompt);
                setVerificationMessageTone('info');
                return;
            }

            // 400/other non-OK statuses
            if (res.status === 400) {
                setVerificationMessageTone('error');
                setVerificationMessage(
                    t('pages.complete.errorCompletingBooking'),
                );
                return;
            }

            // Fallback
            setVerificationMessageTone('error');
            setVerificationMessage(t('pages.complete.errorCompletingBooking'));
        } catch (e) {
            if (!axios.isCancel(e)) {
                setVerificationMessageTone('error');
                setVerificationMessage(
                    t('pages.complete.errorCompletingBooking'),
                );
            }
        } finally {
            setIsResendingCode(false);
        }
    };

    const handleVerificationClose = () => {
        setIsVerificationModalOpen(false);
        setVerificationMessage(null);
        setVerificationMessageTone('info');
        setVerificationCode('');
    };

    const isVerificationInteractionDisabled =
        isSubmittingCode || isResendingCode || !lastSubmittedPayload;
    const isVerificationSubmitDisabled =
        isVerificationInteractionDisabled ||
        verificationCode.trim().length === 0;

    const currency = bookingInfo
        ? currencies.get(bookingInfo.currency.code)
        : null;
    if (!bookingInfo || !currency) {
        return <LoadingPage />;
    }

    return (
        <PaymentRedirectListener
            guid={guid}
            html={response?.redirectHtml ?? null}
            paymentProviderType={response?.paymentProviderType ?? null}
            paymentId={response?.paymentId ?? null}
            onRedirectSuccess={onCompleteSuccess}
            onRedirectError={onCompleteError}
        >
            <Style>
                {/* FORM TIMER */}
                <form
                    onSubmit={handleSubmit(async (values) =>
                        completeBooking(values),
                    )}
                >
                    <div>
                        <HeaderOLD inverted />
                    </div>

                    <div className="compl-forms-container">
                        <div className="container">
                            <div className="compl-header-info container">
                                <p
                                    style={{
                                        fontSize: '40px',
                                        fontWeight: 'bold',
                                        paddingTop: '16px',
                                    }}
                                >
                                    {isWaitingListBooking
                                        ? t('pages.complete.waitingListFor')
                                        : t(
                                              'pages.complete.completeYourReservationFor',
                                          )}{' '}
                                    {bookingInfo.restaurantName}
                                </p>
                            </div>
                            <BookingSummaryCard>
                                <div className="bs-item">
                                    <div className="bs-label">
                                        {t('pages.complete.day')}
                                    </div>
                                    <div className="bs-value">
                                        {bookingInfo.start.format('MMM DD')}
                                    </div>
                                </div>
                                <div className="bs-item">
                                    <div className="bs-label">
                                        {t('pages.complete.time')}
                                    </div>
                                    <div className="bs-value">
                                        {bookingInfo.start.format('HH:mm')}
                                    </div>
                                </div>
                                <div className="bs-item">
                                    <div className="bs-label">
                                        {t('pages.complete.guests')}
                                    </div>
                                    <div className="bs-value">
                                        {bookingInfo.guests}
                                    </div>
                                </div>
                                <div className="bs-item">
                                    <div className="bs-label">
                                        {!isWaitingListBooking
                                            ? t(
                                                  'pages.complete.weAreHoldingThisTable',
                                              )
                                            : t('pages.complete.expiresIn')}
                                    </div>
                                    <div className="bs-value">
                                        <Controller
                                            control={control}
                                            name="expired"
                                            rules={{
                                                validate: () =>
                                                    expires.isValid()
                                                        ? true
                                                        : false,
                                            }}
                                            render={() => (
                                                <ExpirationTimer
                                                    expires={
                                                        expires.isValid()
                                                            ? expires
                                                            : null
                                                    }
                                                    onExpiry={() =>
                                                        setValue(
                                                            'expired',
                                                            true,
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </BookingSummaryCard>

                            <FormSection>
                                <SectionEyebrow>
                                    {t(
                                        'pages.complete.sections.guestDetailsLabel',
                                    )}
                                </SectionEyebrow>
                                <SectionHeading>
                                    {t(
                                        'pages.complete.sections.guestDetailsTitle',
                                    )}
                                </SectionHeading>
                                <SectionSubtitle>
                                    {t('pages.complete.fillOutTheForm')}
                                    {!isWaitingListBooking &&
                                        ` ${t(
                                            'pages.complete.andConfirmReservation',
                                        )}`}
                                    .
                                </SectionSubtitle>
                                <div className="compl-forms-row">
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexBasis: 'calc(50% - 8px)',
                                            marginRight: 16,
                                        }}
                                    >
                                        <Controller
                                            control={control}
                                            name="firstName"
                                            rules={{
                                                required: t(
                                                    'pages.complete.firtNameIsRequired',
                                                ),
                                                validate: (value) =>
                                                    value.length >= 2
                                                        ? true
                                                        : t(
                                                              'pages.complete.firstNameNotValid',
                                                          ),
                                            }}
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    style={{ height: 64 }}
                                                    type="text"
                                                    placeholder={t(
                                                        'pages.complete.firstName',
                                                    )}
                                                />
                                            )}
                                        />
                                        {errors.firstName && (
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    color: 'red',
                                                    margin: 0,
                                                }}
                                            >
                                                {errors.firstName.message}
                                            </p>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            flexBasis: 'calc(50% - 8px)',
                                        }}
                                    >
                                        <Controller
                                            control={control}
                                            name="lastName"
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    style={{ height: 64 }}
                                                    type="text"
                                                    placeholder={t(
                                                        'pages.complete.lastName',
                                                    )}
                                                />
                                            )}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexGrow: 1,
                                        }}
                                    >
                                        <Controller
                                            control={control}
                                            name="emailAddress"
                                            rules={{
                                                required: t(
                                                    'pages.complete.emailIsRequired',
                                                ),
                                                validate: (value) =>
                                                    validateEmail(value)
                                                        ? true
                                                        : t(
                                                              'pages.complete.emailIsNotValid',
                                                          ),
                                            }}
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    style={{ height: 64 }}
                                                    type="email"
                                                    name="email"
                                                    placeholder={t(
                                                        'pages.complete.emailAddress',
                                                    )}
                                                />
                                            )}
                                        />
                                        {errors.emailAddress && (
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    color: 'red',
                                                    margin: 0,
                                                }}
                                            >
                                                {errors.emailAddress.message}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="compl-forms-row">
                                    <div style={{ flexBasis: 0 }}>
                                        <Controller
                                            control={control}
                                            name="countryCode"
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: t(
                                                        'pages.complete.countryCodeIsRequired',
                                                    ),
                                                },
                                            }}
                                            render={({
                                                field: { value, onChange },
                                            }) => (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        minHeight: 64,
                                                        minWidth: 128,
                                                        maxWidth: 144,
                                                    }}
                                                >
                                                    <CountryCodeSelector
                                                        phone={watchPhone}
                                                        code={value}
                                                        onChange={onChange}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>

                                    <div
                                        className="c-phone"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flexBasis: 192,
                                            minWidth: 200,
                                            flexGrow: 1,
                                        }}
                                    >
                                        <Controller
                                            control={control}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: t(
                                                        'pages.complete.phoneIsRequired',
                                                    ),
                                                },
                                                validate: (value) =>
                                                    matchCodeToPhone(
                                                        value,
                                                        getCountryByCode(
                                                            getValues(
                                                                'countryCode',
                                                            ) || 365,
                                                            value,
                                                        )?.region || '',
                                                    )
                                                        ? true
                                                        : t(
                                                              'pages.complete.phoneNotValid',
                                                          ),
                                            }}
                                            name="phone"
                                            render={({ field }) => (
                                                <input
                                                    {...field}
                                                    onChange={field.onChange}
                                                    style={{ height: 64 }}
                                                    autoComplete="tel-national"
                                                    type="tel"
                                                    placeholder={t(
                                                        'pages.complete.phone',
                                                    )}
                                                />
                                            )}
                                        />
                                        {errors.phone && (
                                            <p
                                                style={{
                                                    fontSize: 12,
                                                    color: 'red',
                                                    margin: 0,
                                                }}
                                            >
                                                {errors.phone.message}
                                            </p>
                                        )}
                                    </div>

                                    <Controller
                                        control={control}
                                        name="specialRequest"
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                style={{ height: 64 }}
                                                type="text"
                                                placeholder={t(
                                                    'pages.complete.specialRequest',
                                                )}
                                            />
                                        )}
                                    />
                                </div>

                                {bookingInfo.requireAllergenInfo && (
                                    <DietarySection>
                                        <h3>
                                            {t('pages.complete.dietary.title')}
                                        </h3>
                                        <p>
                                            {t(
                                                'pages.complete.dietary.description',
                                            )}
                                        </p>
                                        <Controller
                                            control={control}
                                            name="hasAllergies"
                                            render={({
                                                field: { onChange, value },
                                            }) => (
                                                <DietaryOptions>
                                                    <DietaryOption
                                                        type="button"
                                                        selected={value}
                                                        onClick={() =>
                                                            onChange(true)
                                                        }
                                                    >
                                                        <span className="c-radio" />
                                                        {t(
                                                            'pages.complete.dietary.yes',
                                                        )}
                                                    </DietaryOption>
                                                    <DietaryOption
                                                        type="button"
                                                        selected={!value}
                                                        onClick={() => {
                                                            onChange(false);
                                                            setValue(
                                                                'bookingDietaryRestrictions',
                                                                '',
                                                            );
                                                        }}
                                                    >
                                                        <span className="c-radio" />
                                                        {t(
                                                            'pages.complete.dietary.no',
                                                        )}
                                                    </DietaryOption>
                                                </DietaryOptions>
                                            )}
                                        />
                                        {watch('hasAllergies') && (
                                            <>
                                                <Controller
                                                    control={control}
                                                    name="bookingDietaryRestrictions"
                                                    rules={{
                                                        validate: (value) =>
                                                            !watch(
                                                                'hasAllergies',
                                                            ) ||
                                                            value.trim()
                                                                .length > 0
                                                                ? true
                                                                : t(
                                                                      'pages.complete.dietary.required',
                                                                  ),
                                                    }}
                                                    render={({ field }) => (
                                                        <DietaryTextArea
                                                            {...field}
                                                            maxLength={2024}
                                                            placeholder={t(
                                                                'pages.complete.dietary.placeholder',
                                                            )}
                                                        />
                                                    )}
                                                />
                                                {errors.bookingDietaryRestrictions && (
                                                    <p
                                                        style={{
                                                            fontSize: 12,
                                                            color: 'red',
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {
                                                            errors
                                                                .bookingDietaryRestrictions
                                                                .message
                                                        }
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </DietarySection>
                                )}
                            </FormSection>

                            {bookingInfo.paymentRequired && (
                                <FormSection>
                                    <SectionEyebrow>
                                        {t(
                                            'pages.complete.sections.paymentLabel',
                                        )}
                                    </SectionEyebrow>
                                    <SectionHeading>
                                        {t(
                                            'pages.complete.sections.paymentTitle',
                                        )}
                                    </SectionHeading>
                                    <div className="compl-forms-row">
                                        {!bookingInfo.isExternalPaymentForm && (
                                            <CreditCardContainer>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        minHeight: 64,
                                                        flexWrap: 'wrap',
                                                        gap: 12,
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Controller
                                                        control={control}
                                                        name="cardNumber"
                                                        rules={{
                                                            required:
                                                                bookingInfo.paymentRequired
                                                                    ? t(
                                                                          'pages.complete.cardNumberIsRequired',
                                                                      )
                                                                    : false,
                                                            validate: (value) =>
                                                                Payment.fns.validateCardNumber(
                                                                    value,
                                                                )
                                                                    ? true
                                                                    : t(
                                                                          'pages.complete.cardNumberIsNotValid',
                                                                      ),
                                                        }}
                                                        render={({
                                                            field: {
                                                                value,
                                                                onChange,
                                                            },
                                                        }) => (
                                                            <div
                                                                style={{
                                                                    position:
                                                                        'relative',
                                                                    flexGrow: 1,
                                                                    minWidth: 220,
                                                                }}
                                                            >
                                                                <input
                                                                    style={{
                                                                        width: '100%',
                                                                        height: 66,
                                                                    }}
                                                                    value={Payment.fns.formatCardNumber(
                                                                        value,
                                                                    )}
                                                                    onChange={
                                                                        onChange
                                                                    }
                                                                    type="text"
                                                                    name="cc-number"
                                                                    placeholder={t(
                                                                        'pages.ta.cardNumber',
                                                                    )}
                                                                />
                                                                <div
                                                                    style={{
                                                                        position:
                                                                            'absolute',
                                                                        right: 16,
                                                                        top: 0,
                                                                        height: '100%',
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    {creditCardIcon(
                                                                        value,
                                                                        !!errors.cardNumber,
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    />
                                                    <Controller
                                                        control={control}
                                                        name="cardExpiry"
                                                        rules={{
                                                            required:
                                                                bookingInfo.paymentRequired
                                                                    ? t(
                                                                          'pages.complete.cardExpiryDateIsRequired',
                                                                      )
                                                                    : false,
                                                            validate: (value) =>
                                                                Payment.fns.validateCardExpiry(
                                                                    value,
                                                                )
                                                                    ? true
                                                                    : t(
                                                                          'pages.complete.cardExpiryDateIsNotValid',
                                                                      ),
                                                        }}
                                                        render={({
                                                            field: {
                                                                value,
                                                                onChange,
                                                            },
                                                        }) => (
                                                            <InputMask
                                                                style={{
                                                                    width: 120,
                                                                    height: 66,
                                                                    textAlign:
                                                                        'center',
                                                                }}
                                                                mask="99/99"
                                                                maskPlaceholder={
                                                                    '--/--'
                                                                }
                                                                value={value}
                                                                onChange={
                                                                    onChange
                                                                }
                                                                type="text"
                                                                name="cc-exp"
                                                                placeholder={
                                                                    '--/--'
                                                                }
                                                            />
                                                        )}
                                                    />

                                                    <Controller
                                                        control={control}
                                                        name="cardCvc"
                                                        rules={{
                                                            required:
                                                                bookingInfo.paymentRequired
                                                                    ? t(
                                                                          'pages.complete.cardCvcIsRequired',
                                                                      )
                                                                    : false,
                                                            validate: (value) =>
                                                                Payment.fns.validateCardCVC(
                                                                    value,
                                                                )
                                                                    ? true
                                                                    : t(
                                                                          'pages.complete.cardCvcIsNotValid',
                                                                      ),
                                                        }}
                                                        render={({
                                                            field: {
                                                                value,
                                                                onChange,
                                                            },
                                                        }) => (
                                                            <input
                                                                style={{
                                                                    textAlign:
                                                                        'center',
                                                                    width: 100,
                                                                    height: 66,
                                                                }}
                                                                value={value}
                                                                onChange={
                                                                    onChange
                                                                }
                                                                maxLength={4}
                                                                type="text"
                                                                name="cc-csc"
                                                                placeholder={
                                                                    'CVC'
                                                                }
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {errors.cardNumber ? (
                                                    <p
                                                        style={{
                                                            fontSize: 12,
                                                            color: 'red',
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {
                                                            errors.cardNumber
                                                                .message
                                                        }{' '}
                                                    </p>
                                                ) : errors.cardExpiry ? (
                                                    <p
                                                        style={{
                                                            fontSize: 12,
                                                            color: 'red',
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {
                                                            errors.cardExpiry
                                                                .message
                                                        }{' '}
                                                    </p>
                                                ) : errors.cardCvc ? (
                                                    <p
                                                        style={{
                                                            fontSize: 12,
                                                            color: 'red',
                                                            margin: 0,
                                                        }}
                                                    >
                                                        {errors.cardCvc.message}{' '}
                                                    </p>
                                                ) : null}
                                            </CreditCardContainer>
                                        )}
                                    </div>
                                    <ChargesCard>
                                        <div className="charges-header">
                                            <i className="material-icons">
                                                info
                                            </i>
                                            <div>
                                                {t(
                                                    'pages.complete.followingChargesApply',
                                                )}
                                            </div>
                                        </div>
                                        <ul>
                                            {bookingInfo.paymentRequirements
                                                .totalPrepaid > 0 && (
                                                <li>
                                                    {t(
                                                        'pages.complete.prepayment',
                                                    )}
                                                    :{' '}
                                                    {currencyFormat(
                                                        bookingInfo
                                                            .paymentRequirements
                                                            .totalPrepaid,
                                                        currency,
                                                        bookingInfo.locale,
                                                    )}
                                                </li>
                                            )}
                                            {bookingInfo.paymentRequirements
                                                .totalNoShow > 0 && (
                                                <>
                                                    <Box height={8} />
                                                    {bookingInfo.noShowText ? (
                                                        <NoShowTextWrapper
                                                            dangerouslySetInnerHTML={{
                                                                __html: normaliseHTMl(
                                                                    bookingInfo.noShowText ??
                                                                        '',
                                                                ),
                                                            }}
                                                        />
                                                    ) : (
                                                        <Typography variant="caption">
                                                            {t(
                                                                'pages.complete.noShowText',
                                                                {
                                                                    restaurantName:
                                                                        bookingInfo.restaurantName,
                                                                },
                                                            )}
                                                        </Typography>
                                                    )}
                                                    <li>
                                                        <div
                                                            style={{
                                                                fontSize: 14,
                                                            }}
                                                        >
                                                            {t(
                                                                'pages.complete.noShowFee',
                                                            )}
                                                            :{' '}
                                                            {currencyFormat(
                                                                bookingInfo
                                                                    .paymentRequirements
                                                                    .totalNoShow,
                                                                currency,
                                                                bookingInfo.locale,
                                                            )}
                                                        </div>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    </ChargesCard>
                                </FormSection>
                            )}

                            {bookingInfo.requirePolicyAccept && (
                                <PolicyCard>
                                    <div className="pc-side">
                                        <SectionEyebrow>
                                            {t(
                                                'pages.complete.sections.pleaseNote',
                                            )}
                                        </SectionEyebrow>
                                        <div className="pc-title">
                                            {t(
                                                'pages.complete.reservationPolicy',
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className="pc-text"
                                        dangerouslySetInnerHTML={{
                                            __html: normaliseHTMl(
                                                bookingInfo.policyText ?? '',
                                            ),
                                        }}
                                    />
                                </PolicyCard>
                            )}

                            <FormSection>
                                <div className="compl-newsletter-checkboxes">
                                    <Controller
                                        control={control}
                                        name="allowSMSMarketing"
                                        render={({
                                            field: { onChange, value },
                                        }) => (
                                            <Checkbox
                                                isChecked={value}
                                                onChange={onChange}
                                                tabIndex={-1}
                                            >
                                                {t(
                                                    'pages.complete.AllowSMSMarketing',
                                                )}
                                                {bookingInfo.restaurantName}
                                            </Checkbox>
                                        )}
                                    />
                                    {bookingInfo.requireEmailMarketingConfirmation && (
                                        <Controller
                                            control={control}
                                            name="allowRestaurantEmails"
                                            render={({
                                                field: { onChange, value },
                                            }) => (
                                                <Checkbox
                                                    isChecked={value}
                                                    onChange={onChange}
                                                    tabIndex={-1}
                                                >
                                                    {t(
                                                        'pages.complete.receiveEmailsFrom',
                                                    )}{' '}
                                                    {bookingInfo.restaurantName}
                                                </Checkbox>
                                            )}
                                        />
                                    )}
                                </div>

                                {acceptTermsError && (
                                    <p className={'compl-terms-error'}>
                                        {acceptTermsError}
                                    </p>
                                )}

                                <div className={'compl-terms-checkbox'}>
                                    <Checkbox
                                        isChecked={acceptTerms}
                                        onChange={() =>
                                            setAcceptTerms((prev) => !prev)
                                        }
                                        tabIndex={-1}
                                    >
                                        <span
                                            className="compl-terms"
                                            dangerouslySetInnerHTML={{
                                                __html: normaliseHTMl(
                                                    `${t(
                                                        'pages.complete.byClickingCompleteBooking',
                                                        {
                                                            interpolation: {
                                                                escapeValue:
                                                                    false,
                                                            },
                                                        },
                                                    )} ${
                                                        bookingInfo.requirePolicyAccept
                                                            ? t(
                                                                  'pages.complete.youAreAlsoAcknowledging',
                                                              )
                                                            : ''
                                                    }`,
                                                ),
                                            }}
                                        />
                                    </Checkbox>
                                </div>

                                <Button
                                    type="submit"
                                    isLoading={isLoading}
                                    disabled={isExpired}
                                >
                                    {isExpired
                                        ? t(
                                              'components.expirationTimer.reservationHasExpired',
                                          )
                                        : t('pages.complete.completeBooking')}
                                </Button>
                            </FormSection>
                        </div>
                    </div>
                </form>
                <Dialog
                    open={isVerificationModalOpen}
                    onClose={handleVerificationClose}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle disableTypography>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Typography variant="h5">
                                {t('pages.complete.emailVerification.title')}
                            </Typography>
                            <IconButton
                                aria-label={t('common.cancel')}
                                onClick={handleVerificationClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Box display="flex" flexDirection="column">
                            <Typography
                                variant="body1"
                                style={{ marginBottom: 8 }}
                            >
                                {t(
                                    'pages.complete.emailVerification.description',
                                )}
                            </Typography>
                            {lastSubmittedPayload?.bookingEmail && (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{ marginBottom: 24 }}
                                >
                                    {t(
                                        'pages.complete.emailVerification.sentTo',
                                        {
                                            email: lastSubmittedPayload.bookingEmail,
                                        },
                                    )}
                                </Typography>
                            )}
                            {verificationMessage && (
                                <Typography
                                    variant="body2"
                                    color={
                                        verificationMessageTone === 'error'
                                            ? 'error'
                                            : 'textSecondary'
                                    }
                                    style={{ marginBottom: 16 }}
                                >
                                    {verificationMessage}
                                </Typography>
                            )}
                            <form onSubmit={handleVerificationSubmit}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    value={verificationCode}
                                    onChange={(event) =>
                                        setVerificationCode(event.target.value)
                                    }
                                    label={t(
                                        'pages.complete.emailVerification.inputLabel',
                                    )}
                                    placeholder={t(
                                        'pages.complete.emailVerification.inputPlaceholder',
                                    )}
                                    autoFocus
                                    disabled={isVerificationInteractionDisabled}
                                    autoComplete="one-time-code"
                                />
                                <Button
                                    type="submit"
                                    isLoading={isSubmittingCode}
                                    disabled={isVerificationSubmitDisabled}
                                    style={{ marginTop: 24 }}
                                >
                                    {t(
                                        'pages.complete.emailVerification.submit',
                                    )}
                                </Button>
                            </form>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                style={{ marginTop: 16 }}
                            >
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    {t(
                                        'pages.complete.emailVerification.resendLabel',
                                    )}
                                </Typography>
                                <ResendCodeButton
                                    type="button"
                                    onClick={handleResendVerificationCode}
                                    disabled={isVerificationInteractionDisabled}
                                >
                                    {t(
                                        'pages.complete.emailVerification.resend',
                                    )}
                                </ResendCodeButton>
                            </Box>
                        </Box>
                    </DialogContent>
                </Dialog>
            </Style>
            <Footer />
        </PaymentRedirectListener>
    );
};

export default Complete;
